import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserActivityLogs, getAllUsers, updateInitialFilters } from "../../../actions/userActivityLogsAction";
import NavbarContainer from "../../Navbar/NavbarContainer";
import "./UserActivity.scss";
import Header from "./UserActivityHeader/Header";
import UserActivityLogsList from "./UserActivityLogsList/UserActivityLogsList";
import ActivityFilters from "./ActivityFilters";
import { getFiltersFromQueryParams, getUserActivityLogsParams } from "./utils/userActivityLogsUtils";
import Tour_activityLogs from "../../../components/MainContent/TourFiles/Tour_activityLogs";

export const initialDuration = { startDate: moment().subtract(6, "days").format("MMM D, YYYY"), endDate: moment().format("MMM D, YYYY") };

export const initialFilterRefineFilter = {
    users: ["selectAll"],
    activityTypes: ["selectAll"],
};
const UserActivity = (props) => {
    const dispatch = useDispatch();
    const companyLiteId = useSelector((state) => state.globalReducer.company.company_lite_company_id);
    const userActivityLogsList = useSelector((state) => state.userActivityLogsReducer.userActivityLists);
    const isLoading = useSelector((state) => state.userActivityLogsReducer.userActivityListLoading);
    const isError = useSelector((state) => state.userActivityLogsReducer.userActivityListError);
    const pages = useSelector((state) => state.userActivityLogsReducer.pages);
    const userTimeZone = useSelector((state) => state.globalReducer.company.user_timezone_name);
    // const duration = useSelector((state) => state.userActivityLogsReducer.duration);
    const durationFilter = useSelector((state) => state.userActivityLogsReducer.filters);
    const filterUpdated = useSelector((state) => state.userActivityLogsReducer.filterUpdated);
    const filterRefineFilter = useSelector((state) => state.userActivityLogsReducer.filterRefineFilter);

    const [showFilters, setShowFilters] = useState(false);
    const [searchText, setSearchText] = useState("");

    const [currentPage, setCurrentPage] = useState(0);
    const [offset, setOffset] = useState(0);
    const [resultsLength, setResultsLength] = useState(0);

    useEffect(() => {
        dispatch(getAllUsers());
        const { params } = getFiltersFromQueryParams(window.location.search);
        if (Object.keys(params)?.length === 0) {
            fetchData();
        } else {
            // let duration = {};
            let filterRefineFilter = {};
            const { startDate, endDate, users, activityTypes, duration, startDateTime, endDateTime, rollingDate } = params;
            console.log("params", params);
            const filters = {
                duration: duration || "7",
                startDateTime,
                endDateTime,
                rollingDate: rollingDate === "true",
            };

            // if (!startDate || !endDate) {
            //     duration = initialDuration;
            // } else
            //     duration = {
            //         startDate,
            //         endDate,
            //     };

            // if (!users || !activityTypes) {
            //     filterRefineFilter = initialFilterRefineFilter;

            // }
            //  else {
            const userLists = users?.length > 0 ? users.split(",")?.map((val) => +val) : ["selectAll"];
            const activityTypeLists = activityTypes?.length > 0 ? activityTypes.split(",") : ["selectAll"];
            filterRefineFilter = {
                users: userLists,
                activityTypes: activityTypeLists,
            };
            // }

            dispatch(updateInitialFilters({ filters, filterRefineFilter }));
        }
    }, []);

    useEffect(() => {
        if (filterUpdated > 0) {
            // let userId = new URLSearchParams(window.location.search).get("id");

            // if (userId || userId !== "") {
            //     setQueryId(userId);
            // }

            // const params = getParams({ userId });

            // dispatch(fetchUserActivityLogs(params));
            // setOffset(0);
            // setCurrentPage((prevVal) => prevVal + 500);
            fetchData();

            // const testParams = new URLSearchParams(window.location.search);

            // console.log("window", window.location);

            // // console.log("deoced", testParams.size, location);
            // testParams.forEach((value, key) => {
            //     console.log(value, key);
            // });
        }
        // }, [duration]);
    }, [filterUpdated]);

    const fetchData = () => {
        const params = getUserActivityLogsParams({ durationFilter, filterRefineFilter, companyLiteId });
        dispatch(fetchUserActivityLogs(params));
        setOffset(0);
        // setCurrentPage((prevVal) => prevVal + 500);
        setCurrentPage(500);
    };
    // if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
    // if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

    const handleObserver = () => {
        setCurrentPage((prevVal) => prevVal + 500);
        setOffset((prev) => prev + 1);
        let offsetVal = offset + 1;
        // console.log("here2 called");
        const params = getUserActivityLogsParams({ pagination: true, offset: offsetVal, durationFilter, filterRefineFilter, companyLiteId });
        dispatch(fetchUserActivityLogs(params));
    };

    // const handleDateConfig = (dateArr) => {
    //     if (dateArr.length === 2) {
    //         let startDate = moment(dateArr[0]).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
    //         let endDate = moment(dateArr[1]).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
    //         dispatch(updateDuration({ startDate, endDate }));
    //     } else dispatch(updateDuration(initialDuration));

    //     // setCurrentPage(0);
    //     // setOffset(0)
    // };
    const componentProps = {
        resultsLength,
        setShowFilters,
        showFilters,
        // setDuration,
        // handleDateConfig,
        searchText,
        setSearchText,
        userActivityLogsList,
        userTimeZone,
        pages,
    };
    return (
        <>
            <div className="user__activity__container">
                <NavbarContainer
                    pageTitle="User Activity"
                    history={props.history}
                    location={props.location}
                    // icon={settingsIcon}
                    tourComponent={Tour_activityLogs}
                />
                <div className="user-activity-div">
                    <Header {...componentProps} />

                    <UserActivityLogsList
                        userActivityLogsList={userActivityLogsList}
                        isLoading={isLoading}
                        isError={isError}
                        userTimeZone={userTimeZone}
                        searchText={searchText}
                        setResultsLength={setResultsLength}
                        resultsLength={resultsLength}
                        currentPage={currentPage}
                        pages={pages}
                        handleObserver={handleObserver}
                    />

                    {showFilters && <ActivityFilters setShowFilters={setShowFilters} />}
                </div>
            </div>
        </>
    );
};

export default UserActivity;
